import { render, staticRenderFns } from "./Hubs.vue?vue&type=template&id=ed12fd5c&"
import script from "./Hubs.vue?vue&type=script&lang=js&"
export * from "./Hubs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports